import React, { memo } from 'react';
import { Text } from '../../../ui-kit';
import '../styles/_total-cost.scss';

// Shared single-line cost row (label + value) used for version subtotals and
// other cost line-items across the platform.
const TotalCost = ({ text, cost }) =>
<div className="total-cost">
    <Text className="total-cost__text" noMargin>
      {text}
    </Text>
    <Text className="total-cost__value" noMargin>
      {cost}
    </Text>
  </div>;


export default memo(TotalCost);
